export const getGatewayOverviewTour = () => [
  {
    target: 'body',
    title: 'Gateways',
    content:
      'Gateways er stedet, hvor du registrerer og administrerer dine ReMoni gateways. Når du har anskaffet en ReMoni Gateway, skal den registreres her, foer den kan bruges til dataopsamling fra ReMoni hardware eller tredjeparts sensorer og målere.',
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '[data-tour="datagrid-toolbar"]',
    spotlightTarget: '[data-tour="gateway-overview-grid"]',
    title: 'Oversigt over dine gateways',
    content:
      'I gateway-tabellen faar du et samlet overblik over de gateways, der er registreret på kontoen. Her kan du blandt andet se gatewayens status, unikke Gateway ID, navn, seneste aktivitet og hvilke forbindelser gatewayen har til ReMoni udstyr eller tredjeparts sensorer og målere.',
    placement: 'auto',
  },
  {
    target: '[data-tour="gateway-overview-add"]',
    title: 'Tilføj ny gateway',
    content:
      'Klik på plus-ikonet øverst til højre ved tabellen for at registrere en ny gateway. Når gatewayen er registreret, kan den bruges til dataopsamling.',
    placement: 'bottom',
  },
  {
    target: '[data-field="actions"]',
    title: 'Administrer en gateway',
    content:
      'I den sidste kolonne på hver række kan du se, redigere eller slette en registreret gateway. Hver række repræsenterer en gateway på kontoen.',
    placement: 'left',
  },
  {
    target: '[data-tour="datagrid-search-trigger"]',
    title: 'Søg efter gateways',
    content:
      'Brug søgefeltet til hurtigt at finde en bestemt gateway. Du kan for eksempel søge på navn, Gateway ID eller andre oplysninger, der vises i tabellen.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="datagrid-columns-trigger"]',
    title: 'Vælg kolonner',
    content:
      'Du kan selv vælge, hvilke kolonner der skal vises i tabellen. Det gør det nemmere at tilpasse overblikket, så du kun ser de oplysninger, der er relevante for dig.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="datagrid-export-trigger"]',
    title: 'Eksporter gateway-data',
    content:
      'Du kan eksportere gateway-tabellen til Excel eller CSV. Det er nyttigt, hvis du vil arbejde videre med data uden for ReCalc eller dele oversigten med andre.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="datagrid-filters-trigger"]',
    title: 'Filtrer gateways',
    content:
      'Brug filtrering til at indsnævre visningen i tabellen. Det kan for eksempel være nyttigt, hvis du kun vil se gateways med en bestemt status eller bestemte forbindelser.',
    placement: 'bottom',
  },
];
